var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('div',{staticClass:"single-sensor"},[_c('Chart',{ref:"chart",attrs:{"chart-data":_vm.chartdata,"options":_vm.otherOptions}}),_c('v-row',{staticClass:"mt-3",attrs:{"justify":"center"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }